import React, { useState } from "react";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const ModalAddWindFarm = ({ isOpen, onClose, onSave, regions, isEmbedded = false }) => {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [region, setRegion] = useState(""); // Nowy stan dla wybranego regionu
  const [isSubmitting, setIsSubmitting] = useState(false);

  const hasRegions = regions && regions.length > 0; // Sprawdzamy, czy są regiony

  const handleSave = async () => {
    // Walidacja pól
    if (!name || !location) {
      alert("Name and location are required.");
      return;
    }
    if (hasRegions && !region) {
      alert("Region is required when regions are available.");
      return;
    }

    setIsSubmitting(true);

    const payload = {
      name,
      location,
      ...(hasRegions && { region: Number(region) }), // Dodajemy region tylko, jeśli są regiony
    };

    console.log("Dane zapisywane dla wind farm:", payload); // Logowanie danych przed wysłaniem

    try {
      const response = await fetch(`${API_BASE_URL}/windfarms/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const savedFarm = await response.json();
      console.log("New wind farm saved:", savedFarm);
      
      // Reset form
      setName("");
      setLocation("");
      setRegion(""); // Resetujemy region po zapisaniu

      onSave(savedFarm.id); // Przekazanie ID nowej farmy do komponentu nadrzędnego
      onClose(); // Zamknięcie modala
    } catch (error) {
      console.error("Error saving wind farm:", error.message);
      alert("Failed to save the wind farm. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    // Reset form
    setName("");
    setLocation("");
    setRegion("");
    onClose(); // Zamknięcie modala
  };

  if (!isOpen) return null;

  // Form content to be reused in both embedded and modal views
  const formContent = (
    <>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Enter farm name"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Location</label>
        <input
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Enter location"
        />
      </div>
      {hasRegions && (
        <div>
          <label className="block text-sm font-medium text-graphite-700">Region</label>
          <select
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            className="w-full border rounded px-3 py-2 mb-6 text-graphite-700"
          >
            <option value="">-- Select Region --</option>
            {regions.map((reg) => (
              <option key={reg.id} value={reg.id}>
                {reg.name}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleCancel}
          className="px-4 py-2  border border-steel-300 text-graphite-700 font-medium rounded-full hover:bg-steel-100 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2  border border-brand-500 bg-brand-500 font-medium text-white rounded-full hover:bg-brand-600 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </>
  );

  // When embedded in the toggle menu
  if (isEmbedded) {
    return (
      <div>
        <h3 className="text-lg font-semibold mb-4">Add New Wind Farm</h3>
        {formContent}
      </div>
    );
  }

  // When used as a standalone modal
  return (
    <div className="fixed inset-0 bg-graphite-950/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Add New Wind Farm</h2>
        {formContent}
      </div>
    </div>
  );
};

export default ModalAddWindFarm;